
const toString = Object.prototype.toString
const originalValueObj = '[object Object]'
const originalValueString = '[object String]'
const originalValueBoolean = '[object Boolean]'
const originalValueUndefined = '[object Undefined]'
const originalValueNull = '[object Null]'
const originalValueSymbol = '[object Symbol]'

export function isDate (val) {
  return toString.call(val) === '[object Date]'
}

export function isPlainObject (val) {
  return toString.call(val) === originalValueObj
}

export function isArray (val) {
  return Array.isArray(val)
}

export function isString (val) {
  return toString.call(val) === originalValueString
}

export function isBoolean (val) {
  return toString.call(val) === originalValueBoolean
}

export function isUndefined (val) {
  return toString.call(val) === originalValueUndefined
}

export function isNull (val) {
  return toString.call(val) === originalValueNull
}

export function isSymbol (val) {
  return toString.call(val) === originalValueSymbol
}

//是否为空
export function isEmpty(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "") !== ""
}
